/**
 * Cashfree JS SDK loader — uses official CDN (https://sdk.cashfree.com/js/v3/cashfree.js)
 * to avoid bundling. Exposes `loadCashfree(mode)` returning the SDK instance.
 */

let _sdkPromise = null;

function _loadScript() {
  if (_sdkPromise) return _sdkPromise;
  _sdkPromise = new Promise((resolve, reject) => {
    if (typeof window.Cashfree !== "undefined") return resolve();
    const script = document.createElement("script");
    script.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("Failed to load Cashfree SDK"));
    document.head.appendChild(script);
  });
  return _sdkPromise;
}

export async function loadCashfree(mode = "TEST") {
  await _loadScript();
  if (typeof window.Cashfree !== "function") {
    throw new Error("Cashfree SDK not available on window");
  }
  // Cashfree v3 global accepts { mode: "sandbox" | "production" }
  return window.Cashfree({ mode: mode === "LIVE" ? "production" : "sandbox" });
}
